

























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import HeaderDesktop from '@/components/HeaderDesktop.vue';
import FooterOne from '@/components/FooterOne.vue';

@Component({
  components: {
  HeaderDesktop,
  FooterOne,
  },
})
export default class App extends Vue {

  public created() {
    this.customizeVueMoment();
  }

  private customizeVueMoment() {
    moment.updateLocale('en', {
    months : [
        'styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec',
        'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień' ],
    monthsShort : [
        'sty', 'lut', 'mar', 'kwi', 'maj', 'cze',
        'lip', 'sie', 'wrz', 'paź', 'lis', 'gru' ],
    weekdays : [
        'niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota' ],
    weekdaysShort : ['niedz', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob' ],
    weekdaysMin : ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'sb' ],
    longDateFormat : {
        LT: 'h:mm A',
        LTS: 'h:mm:ss A',
        L: 'MM/DD/YYYY',
        l: 'M/D/YYYY',
        LL: 'MMMM Do YYYY',
        ll: 'MMM D YYYY',
        LLL: 'MMMM Do YYYY LT',
        lll: 'MMM D YYYY LT',
        LLLL: 'dddd, MMMM Do YYYY LT',
        llll: 'ddd, MMM D YYYY LT' },
    relativeTime : {
        future: 'za %s',
        past:   '%s temu',
        s  : 'kilka sekund',
        ss : '%d sekund',
        m:  'minuta',
        mm: '%d minut',
        h:  'godzina',
        hh: '%d godzin',
        d:  'dzień',
        dd: '%d dni',
        M:  'miesiąc',
        MM: '%d miesięcy',
        y:  'rok',
        yy: '%d lat' },
    calendar : {
        lastDay : '[Yesterday at] LT',
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        lastWeek : '[last] dddd [at] LT',
        nextWeek : 'dddd [at] LT',
        sameElse : 'L' },
    });
  }

}
